module.exports = __webpack_public_path__ + "01c234a7a162bdd44e3af892911bf3e7.svg";